<template>
  <div  class="login-container">
    <p class="name">安全生产信息化运营平台</p>
    <div class="content">
      <div class="imgBox">
        <img alt="" src="../../assets/images/login/login_left.png">
      </div>
      <div class="rightBox">
        <div class="formBox">
          <div class="display-flex fd-column ai-center pb-30">
            <b class="fs-28 mb-16">欢迎使用</b>
            <span class="color-info fs-14">请输入登录信息</span>
          </div>
          <el-form :model="form" ref="form" class="mt-20">
            <el-form-item
              prop="username"
              :rules="[
                { required: true, message: '用户名不能为空', trigger: 'blur'} ]">
              <el-input
                clearable
                ref="username"
                v-model="form.username"
                placeholder="请输入手机号"
                type="text"
                tabindex="2"
                @keyup.enter.native="handleLogin"></el-input>
            </el-form-item>
            <el-form-item
              prop="password"
              :rules="[
                { required: true, message: '登录密码不能为空',trigger: 'blur'} ]">
              <el-input
                clearable
                @keyup.enter.native="handleLogin"
                ref="password"
                v-model="form.password"
                type="password"
                show-password
                placeholder="请输入密码"
                tabindex="2"></el-input>
            </el-form-item>
            <el-form-item class="ta-right">
              <el-checkbox v-model="checked">记住密码</el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button class="width-percent-100" :loading="loading" type="primary" @click.native.prevent="handleLogin">
                {{ loading ? '登录中' : '登录' }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'loginNew',
  components: {},
  props: {},
  data () {
    return {
      loading: false,
      form: {
        username: '',
        password: ''

      },
      checked: false // 是否记住密码
    }
  },
  filters: {},
  computed: {},
  watch: {},
  methods: {
    /**
     * 登录
     */
    handleLogin () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          if (this.checked) {
            this.$cookies.set('username', this.form.username, { expires: 7 })
            this.$cookies.set('password', this.$methods.encrypt(this.form.password), { expires: 7 })
          }
          const data = {
            terminal: 1,
            username: this.form.username,
            password: this.form.password
          }
          this.$api.user.login(data).then(res => {
            this.$cookies.set('token', 'Bearer ' + res, { expires: 7 })
            this.$store.commit('SET_TOKEN', `Bearer ${res}`)
            this.$api.user.getMyMenu().then(_res => {
              this.$router.push(_res[0].children[0].href)
            })
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }
  },
  beforeCreate () {
  },
  created () {
    if (this.$cookies.get('username') && this.$cookies.get('password')) {
      this.form.username = this.$cookies.get('username')
      this.form.password = this.$methods.decrypt(this.$cookies.get('password'))
      this.checked = true
    }
    this.$cookies.remove('token')
  },
  beforeMount () {
  },
  mounted () {

  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.login-container{
  width: 100%;
  height: 100%;
  background-color: #4E9AFF;
  display: flex;
  justify-content:center;
  align-items: center;
  flex-direction:column;
  .name{
    font-size: 36px;
    color:#FFFFFF;
    margin: 0 0 90px;
  }
  .content{
    width: 1182px;
    height: 603px;
    background-color: #FFFFFF;
    display: flex;
    border-radius: 12px;
    .imgBox{
      img{
        width: 100%;
        height: 100%;
      }
    }
    .rightBox{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      .formBox {
        width: 340px;
      }
    }

  }
}

</style>
